"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StationBoardInactiveZoomPreset = exports.StationBoardTurnoutStartCondition = exports.StationBoardActiveZoom = exports.StationBoardBaseLayer = exports.StationBoardInactiveLayer = exports.StationBoardActiveLayer = exports.FullStationBoard = exports.BasicStationBoard = exports.StationBoardSession = exports.MinimalStationBoard = void 0;
exports.presetToInactiveZoom = presetToInactiveZoom;
var cerealParse_1 = require("../cerealParse");
var group_1 = require("./group");
var agency_1 = require("./agency");
/**
 * Class representing a minimal station board and providing a static parse method.
 */
var MinimalStationBoard = /** @class */ (function () {
    function MinimalStationBoard(id, name, sessionCount) {
        this.id = id;
        this.name = name;
        this.sessionCount = sessionCount;
    }
    /**
     * Parse object potentially representing a MinimalStationBoard.
     * @param o
     * @return Parse result
     */
    MinimalStationBoard.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new MinimalStationBoard(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getNumber(o, 'sessionCount')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid MinimalStationBoard Model: ".concat(e.message));
        }
    };
    return MinimalStationBoard;
}());
exports.MinimalStationBoard = MinimalStationBoard;
/**
 * Class representing a station board session and providing a static parse method.
 */
var StationBoardSession = /** @class */ (function () {
    function StationBoardSession(id, name, creation, lastConnected) {
        this.id = id;
        this.name = name;
        this.creation = creation;
        this.lastConnected = lastConnected;
    }
    /**
     * Parse object potentially representing a StationBoardSession.
     * @param o
     * @return Parse result
     */
    StationBoardSession.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new StationBoardSession(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'creationTs'), cerealParse_1.ParseUtils.getUNIXTimestampDateOrNull(o, 'lastConnectedTs')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid StationBoardSession Model: ".concat(e.message));
        }
    };
    return StationBoardSession;
}());
exports.StationBoardSession = StationBoardSession;
/**
 * Class representing a basic station board and providing a static parse method.
 */
var BasicStationBoard = /** @class */ (function () {
    function BasicStationBoard(id, name, units, messagingGroup, station, activeLayers, inactiveLayers, baseLayer, activeZoom, activeTime, userInactiveTime, userExpireTime, apparatusInactiveTime, apparatusExpireTime, dayStartMin, dayEndMin, dayTurnoutTime, nightTurnoutTime, redTime, blinkTime, turnoutStart) {
        this.id = id;
        this.name = name;
        this.units = units;
        this.messagingGroup = messagingGroup;
        this.station = station;
        this.activeLayers = activeLayers;
        this.inactiveLayers = inactiveLayers;
        this.baseLayer = baseLayer;
        this.activeZoom = activeZoom;
        this.activeTime = activeTime;
        this.userInactiveTime = userInactiveTime;
        this.userExpireTime = userExpireTime;
        this.apparatusInactiveTime = apparatusInactiveTime;
        this.apparatusExpireTime = apparatusExpireTime;
        this.dayStartMin = dayStartMin;
        this.dayEndMin = dayEndMin;
        this.dayTurnoutTime = dayTurnoutTime;
        this.nightTurnoutTime = nightTurnoutTime;
        this.redTime = redTime;
        this.blinkTime = blinkTime;
        this.turnoutStart = turnoutStart;
        this.dayStart = BasicStationBoard.constructDateFromMinutes(dayStartMin);
        this.dayEnd = BasicStationBoard.constructDateFromMinutes(dayEndMin);
    }
    /**
     * Construct date from minutes.
     * @param mins
     * @return Date
     */
    BasicStationBoard.constructDateFromMinutes = function (mins) {
        var date = new Date();
        var dayStartHours = Math.floor(mins / 60);
        var dayStartMinutes = mins - (dayStartHours * 60);
        date.setHours(dayStartHours);
        date.setMinutes(dayStartMinutes);
        return date;
    };
    /**
     * Parse object potentially representing a BasicStationBoard.
     * @param o
     * @return Parse result
     */
    BasicStationBoard.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new BasicStationBoard(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'units', group_1.NamedGroup.parse, 'warn'), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'messagingGroup', group_1.NamedGroup.parse), cerealParse_1.ParseUtils.getSubobject(o, 'station', agency_1.Station.parse), cerealParse_1.ParseUtils.getArray(o, 'activeLayers')
                .map(function (layerString) { return StationBoardActiveLayer[layerString]; }), cerealParse_1.ParseUtils.getArray(o, 'inactiveLayers')
                .map(function (layerString) { return StationBoardInactiveLayer[layerString]; }), cerealParse_1.ParseUtils.getEnum(o, 'baseLayer', StationBoardBaseLayer), cerealParse_1.ParseUtils.getEnum(o, 'activeZoom', StationBoardActiveZoom), cerealParse_1.ParseUtils.getNumber(o, 'activeTime'), cerealParse_1.ParseUtils.getNumber(o, 'userInactiveTime'), cerealParse_1.ParseUtils.getNumber(o, 'userExpireTime'), cerealParse_1.ParseUtils.getNumber(o, 'apparatusInactiveTime'), cerealParse_1.ParseUtils.getNumber(o, 'apparatusExpireTime'), cerealParse_1.ParseUtils.getNumber(o, 'dayStart'), cerealParse_1.ParseUtils.getNumber(o, 'dayEnd'), cerealParse_1.ParseUtils.getNumber(o, 'dayTurnoutTime'), cerealParse_1.ParseUtils.getNumber(o, 'nightTurnoutTime'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'redTime'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'blinkTime'), cerealParse_1.ParseUtils.getEnum(o, 'turnoutStart', StationBoardTurnoutStartCondition)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid BasicStationBoard Model: ".concat(e.message));
        }
    };
    return BasicStationBoard;
}());
exports.BasicStationBoard = BasicStationBoard;
/**
 * Class representing a full station board and providing a static parse method.
 */
var FullStationBoard = /** @class */ (function () {
    function FullStationBoard(id, name, units, messagingGroup, station, activeLayers, inactiveLayers, baseLayer, activeZoom, inactiveZoom, activeTime, messageDuration, userInactiveTime, userExpireTime, apparatusInactiveTime, apparatusExpireTime, dayStartMin, dayEndMin, dayTurnoutTime, nightTurnoutTime, redTime, blinkTime, turnoutStart, isZoned, sessions) {
        this.id = id;
        this.name = name;
        this.units = units;
        this.messagingGroup = messagingGroup;
        this.station = station;
        this.activeLayers = activeLayers;
        this.inactiveLayers = inactiveLayers;
        this.baseLayer = baseLayer;
        this.activeZoom = activeZoom;
        this.inactiveZoom = inactiveZoom;
        this.activeTime = activeTime;
        this.messageDuration = messageDuration;
        this.userInactiveTime = userInactiveTime;
        this.userExpireTime = userExpireTime;
        this.apparatusInactiveTime = apparatusInactiveTime;
        this.apparatusExpireTime = apparatusExpireTime;
        this.dayStartMin = dayStartMin;
        this.dayEndMin = dayEndMin;
        this.dayTurnoutTime = dayTurnoutTime;
        this.nightTurnoutTime = nightTurnoutTime;
        this.redTime = redTime;
        this.blinkTime = blinkTime;
        this.turnoutStart = turnoutStart;
        this.isZoned = isZoned;
        this.sessions = sessions;
        this.dayStart = FullStationBoard.constructDateFromMinutes(dayStartMin);
        this.dayEnd = FullStationBoard.constructDateFromMinutes(dayEndMin);
    }
    /**
     * Construct date from minutes.
     * @param mins
     * @return Date
     */
    FullStationBoard.constructDateFromMinutes = function (mins) {
        var date = new Date();
        var dayStartHours = Math.floor(mins / 60);
        var dayStartMinutes = mins - (dayStartHours * 60);
        date.setHours(dayStartHours);
        date.setMinutes(dayStartMinutes);
        return date;
    };
    /**
     * Parse object potentially representing a FullStationBoard.
     * @param o
     * @return Parse result
     */
    FullStationBoard.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new FullStationBoard(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'name'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'units', group_1.NamedGroup.parse, 'warn'), cerealParse_1.ParseUtils.getSubobjectOrNull(o, 'messagingGroup', group_1.NamedGroup.parse), cerealParse_1.ParseUtils.getSubobject(o, 'station', agency_1.Station.parse), cerealParse_1.ParseUtils.getArray(o, 'activeLayers')
                .map(function (layerString) { return StationBoardActiveLayer[layerString]; }), cerealParse_1.ParseUtils.getArray(o, 'inactiveLayers')
                .map(function (layerString) { return StationBoardInactiveLayer[layerString]; }), cerealParse_1.ParseUtils.getEnum(o, 'baseLayer', StationBoardBaseLayer), cerealParse_1.ParseUtils.getEnum(o, 'activeZoom', StationBoardActiveZoom), cerealParse_1.ParseUtils.getSubobject(o, 'inactiveZoom', parseStationBoardInactiveZoom), cerealParse_1.ParseUtils.getNumber(o, 'activeTime'), cerealParse_1.ParseUtils.getNumber(o, 'messageDuration'), cerealParse_1.ParseUtils.getNumber(o, 'userInactiveTime'), cerealParse_1.ParseUtils.getNumber(o, 'userExpireTime'), cerealParse_1.ParseUtils.getNumber(o, 'apparatusInactiveTime'), cerealParse_1.ParseUtils.getNumber(o, 'apparatusExpireTime'), cerealParse_1.ParseUtils.getNumber(o, 'dayStart'), cerealParse_1.ParseUtils.getNumber(o, 'dayEnd'), cerealParse_1.ParseUtils.getNumber(o, 'dayTurnoutTime'), cerealParse_1.ParseUtils.getNumber(o, 'nightTurnoutTime'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'redTime'), cerealParse_1.ParseUtils.getNumberOrNull(o, 'blinkTime'), cerealParse_1.ParseUtils.getEnum(o, 'turnoutStart', StationBoardTurnoutStartCondition), cerealParse_1.ParseUtils.getBoolean(o, 'zoned'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'sessions', StationBoardSession.parse, 'warn')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid FullStationBoard Model: ".concat(e.message));
        }
    };
    /**
     * Get inactive zoom preset for station board.
     * @TODO Convert to get method
     * @return Inactive zoom preset
     */
    FullStationBoard.prototype.inactiveZoomPreset = function () {
        if (this.inactiveZoom.type == 'boundary') {
            return StationBoardInactiveZoomPreset.boundary;
        }
        else {
            var realDistance_1 = this.inactiveZoom.distance;
            var matchedPreset = presetInfo.filter(function (i) { return i.distance == realDistance_1; })[0];
            return matchedPreset != null ? matchedPreset.preset : null;
        }
    };
    return FullStationBoard;
}());
exports.FullStationBoard = FullStationBoard;
var StationBoardActiveLayer;
(function (StationBoardActiveLayer) {
    StationBoardActiveLayer[StationBoardActiveLayer["responders"] = 0] = "responders";
    StationBoardActiveLayer[StationBoardActiveLayer["supplementals"] = 1] = "supplementals";
    StationBoardActiveLayer[StationBoardActiveLayer["route"] = 2] = "route";
    StationBoardActiveLayer[StationBoardActiveLayer["hydrants"] = 3] = "hydrants";
    StationBoardActiveLayer[StationBoardActiveLayer["users"] = 4] = "users";
    StationBoardActiveLayer[StationBoardActiveLayer["apparatus"] = 5] = "apparatus";
    StationBoardActiveLayer[StationBoardActiveLayer["turnout"] = 6] = "turnout";
    StationBoardActiveLayer[StationBoardActiveLayer["streetView"] = 7] = "streetView";
    StationBoardActiveLayer[StationBoardActiveLayer["criticalBanner"] = 8] = "criticalBanner";
})(StationBoardActiveLayer || (exports.StationBoardActiveLayer = StationBoardActiveLayer = {}));
var StationBoardInactiveLayer;
(function (StationBoardInactiveLayer) {
    StationBoardInactiveLayer[StationBoardInactiveLayer["users"] = 0] = "users";
    StationBoardInactiveLayer[StationBoardInactiveLayer["apparatus"] = 1] = "apparatus";
    StationBoardInactiveLayer[StationBoardInactiveLayer["stations"] = 2] = "stations";
    StationBoardInactiveLayer[StationBoardInactiveLayer["openJobs"] = 3] = "openJobs";
    StationBoardInactiveLayer[StationBoardInactiveLayer["currentWeather"] = 4] = "currentWeather";
    StationBoardInactiveLayer[StationBoardInactiveLayer["forecast5"] = 5] = "forecast5";
})(StationBoardInactiveLayer || (exports.StationBoardInactiveLayer = StationBoardInactiveLayer = {}));
var StationBoardBaseLayer;
(function (StationBoardBaseLayer) {
    StationBoardBaseLayer[StationBoardBaseLayer["streets"] = 0] = "streets";
    StationBoardBaseLayer[StationBoardBaseLayer["satellite"] = 1] = "satellite";
    StationBoardBaseLayer[StationBoardBaseLayer["hybrid"] = 2] = "hybrid";
    StationBoardBaseLayer[StationBoardBaseLayer["dark"] = 3] = "dark";
    StationBoardBaseLayer[StationBoardBaseLayer["highContrast"] = 4] = "highContrast";
})(StationBoardBaseLayer || (exports.StationBoardBaseLayer = StationBoardBaseLayer = {}));
var StationBoardActiveZoom;
(function (StationBoardActiveZoom) {
    StationBoardActiveZoom[StationBoardActiveZoom["none"] = 0] = "none";
    StationBoardActiveZoom[StationBoardActiveZoom["jobLocation"] = 1] = "jobLocation";
    StationBoardActiveZoom[StationBoardActiveZoom["halfRoute"] = 2] = "halfRoute";
    StationBoardActiveZoom[StationBoardActiveZoom["fullRoute"] = 3] = "fullRoute";
})(StationBoardActiveZoom || (exports.StationBoardActiveZoom = StationBoardActiveZoom = {}));
var StationBoardTurnoutStartCondition;
(function (StationBoardTurnoutStartCondition) {
    StationBoardTurnoutStartCondition[StationBoardTurnoutStartCondition["receivedTime"] = 0] = "receivedTime";
    StationBoardTurnoutStartCondition[StationBoardTurnoutStartCondition["jobTime"] = 1] = "jobTime";
    StationBoardTurnoutStartCondition[StationBoardTurnoutStartCondition["jobCreation"] = 2] = "jobCreation";
})(StationBoardTurnoutStartCondition || (exports.StationBoardTurnoutStartCondition = StationBoardTurnoutStartCondition = {}));
/**
 * Parse object potentially representing a StationBoardInactiveZoom.
 * @param o
 * @return Parse result
 */
function parseStationBoardInactiveZoom(o) {
    try {
        var type = cerealParse_1.ParseUtils.getString(o, 'type');
        if (type == 'boundary') {
            return cerealParse_1.ParseUtils.parseSuccess({ type: 'boundary' });
        }
        else if (type == 'custom') {
            return cerealParse_1.ParseUtils.parseSuccess({
                type: 'custom',
                distance: cerealParse_1.ParseUtils.getNumber(o, 'distance'),
            });
        }
        else {
            return cerealParse_1.ParseUtils.parseFailure("Invalid StationBoardInactiveZoom Model: Invalid type '".concat(type, "'"));
        }
    }
    catch (e) {
        return cerealParse_1.ParseUtils.parseFailure("Invalid StationBoardInactiveZoom Model: ".concat(e.message));
    }
}
var StationBoardInactiveZoomPreset;
(function (StationBoardInactiveZoomPreset) {
    StationBoardInactiveZoomPreset[StationBoardInactiveZoomPreset["boundary"] = 0] = "boundary";
    StationBoardInactiveZoomPreset[StationBoardInactiveZoomPreset["r25mi"] = 1] = "r25mi";
    StationBoardInactiveZoomPreset[StationBoardInactiveZoomPreset["r20mi"] = 2] = "r20mi";
    StationBoardInactiveZoomPreset[StationBoardInactiveZoomPreset["r15mi"] = 3] = "r15mi";
    StationBoardInactiveZoomPreset[StationBoardInactiveZoomPreset["r10mi"] = 4] = "r10mi";
    StationBoardInactiveZoomPreset[StationBoardInactiveZoomPreset["r5mi"] = 5] = "r5mi";
    StationBoardInactiveZoomPreset[StationBoardInactiveZoomPreset["r1mi"] = 6] = "r1mi";
})(StationBoardInactiveZoomPreset || (exports.StationBoardInactiveZoomPreset = StationBoardInactiveZoomPreset = {}));
var presetInfo = [
    { preset: StationBoardInactiveZoomPreset.r25mi, distance: 40200 },
    { preset: StationBoardInactiveZoomPreset.r20mi, distance: 32200 },
    { preset: StationBoardInactiveZoomPreset.r15mi, distance: 24100 },
    { preset: StationBoardInactiveZoomPreset.r10mi, distance: 16100 },
    { preset: StationBoardInactiveZoomPreset.r5mi, distance: 8100 },
    { preset: StationBoardInactiveZoomPreset.r1mi, distance: 1600 },
];
/**
 * Convert preset to inacrive zoom.
 * @param preset
 * @return Station board inactive zoom
 */
function presetToInactiveZoom(preset) {
    if (preset == StationBoardInactiveZoomPreset.boundary) {
        return { type: 'boundary' };
    }
    else {
        return { type: 'custom', distance: presetInfo.filter(function (i) { return i.preset == preset; })[0].distance };
    }
}
//# sourceMappingURL=stationBoard.js.map